import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

const AuthVerify = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setAuthData } = useContext(AuthContext);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const hasStarted = React.useRef(false);

  useEffect(() => {
    if (hasStarted.current) return;
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (!token) {
      setError("No token provided.");
      setLoading(false);
      return;
    }

    hasStarted.current = true;
    const verify = async () => {
      try {
        const res = await fetch("/api/auth/verify", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token }),
        });

        let data;
        const contentType = res.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          data = await res.json();
        } else {
          const text = await res.text();
          throw new Error(`Server returned non-JSON response (${res.status} ${res.statusText}): ${text.substring(0, 100)}`);
        }

        if (res.ok) {
          console.log('Verification successful, data:', { ...data, token: data.token ? 'PRESENT' : 'MISSING' });
          // Store user AND token in context & localStorage
          if (!data.token) {
            console.error('SERVER DID NOT RETURN TOKEN!');
          }
          setAuthData(data.user, data.token);
          navigate("/dashboard");
        } else {
          setError(data.error || "Invalid or expired token.");
        }
      } catch (err) {
        console.error('Verification error:', err);
        setError(err.message.includes('non-JSON') ? err.message : "Server not available or connection refused.");
      } finally {
        setLoading(false);
      }
    };
    verify();
    // eslint-disable-next-line
  }, [location.search, setAuthData, navigate]);

  if (loading) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1, flexDirection: 'column', gap: '20px' }}>
      <div className="spinner"></div>
      <p style={{ color: '#666' }}>Verifying magic link...</p>
    </div>
  );

  if (error) return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1, flexDirection: 'column', gap: '20px', textAlign: 'center', padding: '40px' }}>
      <div className="message error" style={{
        background: '#fff1f0',
        color: '#cf1322',
        padding: '20px 30px',
        borderRadius: '12px',
        border: '1px solid #ffa39e',
        boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
        maxWidth: '400px'
      }}>
        <h3 style={{ margin: '0 0 10px 0' }}>Verification Failed</h3>
        <p style={{ margin: 0 }}>{error}</p>
      </div>
      <div>
        <button
          onClick={() => navigate('/login')}
          style={{
            backgroundColor: '#4a90e2',
            color: 'white',
            padding: '12px 32px',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: '600',
            transition: 'all 0.2s',
            boxShadow: '0 4px 12px rgba(74, 144, 226, 0.3)'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = '#357abd';
            e.currentTarget.style.transform = 'translateY(-1px)';
            e.currentTarget.style.boxShadow = '0 6px 16px rgba(74, 144, 226, 0.4)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = '#4a90e2';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(74, 144, 226, 0.3)';
          }}
        >
          Back to Login
        </button>
      </div>
    </div>
  );
  return null;
};

export default AuthVerify; 